import { defineComponent } from 'vue';

/** Dock tab title only — no close action (Control Designer tabs must stay open). */
export default defineComponent({
    name: 'ControlDesignerDockTab',
    props: {
        params: { type: Object, required: true },
    },
    data() {
        return {
            title: '',
            _titleDisposable: null,
        };
    },
    watch: {
        params: {
            immediate: true,
            handler(p) {
                this._titleDisposable?.dispose?.();
                this._titleDisposable = null;
                if (!p?.api) {
                    this.title = '';
                    return;
                }
                this.title = p.api.title ?? '';
                this._titleDisposable = p.api.onDidTitleChange?.((event) => {
                    this.title = event.title ?? '';
                });
            },
        },
    },
    beforeUnmount() {
        this._titleDisposable?.dispose?.();
    },
    render() {
        return (
            <div class="dv-default-tab control-designer-dock-tab">
                <div class="dv-default-tab-content">{this.title}</div>
            </div>
        );
    },
});
